// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"70a49f1d","389":"8d92df96","453":"8300fad7","732":"717bcb65","977":"e179ae19"}[chunkId] + ".chunk.js";
};